import { Text, tokens } from '@fluentui/react-components';
import { useClasses } from 'shared/components/token-usage/TokenUsageLegendItem';
import { ITokenUsageViewDetails } from 'shared/models/TokenUsage';

interface ITokenUsageLegendLabel {
    details: ITokenUsageViewDetails;
}

export const TokenUsageLegendLabel: React.FC<ITokenUsageLegendLabel> = ({ details }) => {
    const classes = useClasses();
    return (
        <div className={classes.root}>
            <div
                style={{
                    backgroundColor: details.color,
                    height: tokens.spacingVerticalMNudge,
                    width: tokens.spacingHorizontalMNudge,
                }}
            />
            <Text>{`${details.legendLabel} (${details.usageCount})`}</Text>
        </div>
    );
};
